import { DecimalPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

const CURRENCY_SYMBOL = 0;
const CURRENCY_RATE = 1;

@Pipe({
  name: 'toCurrency',
  standalone: false,
})
export class ToCurrencyPipe implements PipeTransform {
  readonly #decimalPipe = inject(DecimalPipe);

  transform(value: number | string, ...args: any[]): string {
    const symbol = args[CURRENCY_SYMBOL];
    const rate = args[CURRENCY_RATE];

    if (rate && typeof value === 'number') {
      value = value * rate;
    }

    if (typeof value === 'number') {
      value = this.#decimalPipe.transform(value);
    }

    return `${symbol || ''} ${value || '0'}`;
  }
}
